import React, { useState } from "react";
import { Send } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { PageHead } from "./Shop";
import OfficeCards from "../components/OfficeCards";
import { useToast } from "../hooks/use-toast";
import { api } from "../api";
import useSeo from "../hooks/useSeo";

const Contact = () => {
  const { ui } = useLang();
  const { toast } = useToast();
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [sending, setSending] = useState(false);
  useSeo({
    title: ui.nav.contactInfo,
    description: { en: "Contact HAAS Mosaic — reach us by phone, email or WhatsApp for custom marble mosaic commissions and quotes.", tr: "HAAS Mosaic İletişim — özel mermer mozaik siparişleri ve teklifler için telefon, e-posta veya WhatsApp ile bize ulaşın." },
  });

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.sendContact(form);
      toast({ title: "HAAS Mosaic", description: ui.contactForm.sent });
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch (err) {
      toast({ title: "HAAS Mosaic", description: "Error / Hata", variant: "destructive" });
    } finally {
      setSending(false);
    }
  };

  const field = "w-full bg-white border border-[#e0d6c6] px-4 py-3.5 text-[15px] text-[#211d18] placeholder:text-[#a89c88] focus:outline-none focus:border-[#a67c52] transition-colors";

  return (
    <div className="bg-[#f7f3ee]">
      <PageHead title={ui.contactUs} subtitle={ui.ctaText} image="/mosaic/2025/08/contact1.jpg" imagePosition="center top" />
      <section className="py-16 md:py-24">
        <div className="max-w-[1360px] mx-auto px-5 md:px-8 grid md:grid-cols-5 gap-12">
          {/* Info */}
          <div className="md:col-span-2">
            <p className="text-[#a67c52] text-[12px] uppercase tracking-luxe mb-3">HAAS MOSAIC</p>
            <h2 className="font-serif text-4xl text-[#211d18] mb-6">{ui.getInTouch}</h2>
            <p className="text-[#5a5348] text-[16px] leading-relaxed mb-8">{ui.footerAbout}</p>
            <OfficeCards variant="light" />
          </div>
          {/* Form */}
          <div className="md:col-span-3">
            <form onSubmit={submit} className="bg-[#efe7db] p-8 md:p-10">
              <div className="grid sm:grid-cols-2 gap-5 mb-5">
                <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder={ui.contactForm.name} className={field} />
                <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder={ui.contactForm.email} className={field} />
              </div>
              <input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder={ui.contactForm.phone} className={`${field} mb-5`} />
              <textarea required rows={6} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} placeholder={ui.contactForm.message} className={`${field} mb-6 resize-none`} />
              <button type="submit" disabled={sending} className="inline-flex items-center gap-2.5 bg-[#211d18] hover:bg-[#a67c52] disabled:opacity-60 text-white text-[13px] uppercase tracking-[0.16em] px-8 py-4 transition-colors">
                <Send size={16} /> {ui.contactForm.send}
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
